module.exports = __webpack_public_path__ + "img/montserrat-regular-webfont.5297f256.svg";